import { render } from "./ShippingModal.vue?vue&type=template&id=2fccba61&scoped=true"
import script from "./ShippingModal.vue?vue&type=script&lang=js"
export * from "./ShippingModal.vue?vue&type=script&lang=js"

import "./ShippingModal.vue?vue&type=style&index=0&id=2fccba61&scoped=true&lang=css"
import "./ShippingModal.vue?vue&type=style&index=1&id=2fccba61&lang=css"

import exportComponent from "/home/dyam/Documentos/LBP/mi-stock-lbp-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fccba61"]])

export default __exports__